var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormErr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_78539",
    "data-name": "Group 78539",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.234,
    height: 25.234,
    viewBox: "0 0 25.234 25.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18154",
    "data-name": "Rectangle 18154",
    width: 25.234,
    height: 25.234,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_78538",
    "data-name": "Group 78538",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59268",
    "data-name": "Path 59268",
    d: "M25.234,12.617A12.617,12.617,0,1,1,12.617,0,12.617,12.617,0,0,1,25.234,12.617",
    fill: "#c60202"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59269",
    "data-name": "Path 59269",
    d: "M60.942,58.434l-2.811-2.811,2.811-2.81a1.788,1.788,0,1,0-2.509-2.51l-2.811,2.811L52.811,50.3A1.788,1.788,0,1,0,50.3,52.812l2.811,2.811L50.3,58.434a1.788,1.788,0,1,0,2.509,2.509l2.811-2.811,2.811,2.811a1.788,1.788,0,1,0,2.509-2.509",
    transform: "translate(-43.005 -43.006)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormErr);
export default __webpack_public_path__ + "static/media/form_err.39e2fbe9af879f0ff41da3f41803d0dc.svg";
export { ForwardRef as ReactComponent };